<template>
<div style="height: 100%;margin: 0 20px">
  <div v-if="isWeiNing" style="height: calc(100% - 20px);padding-top: 10px;">
    <el-row style="height: 100%;">
      <el-col :span="8" class="col-height">
        <div style="height: 160px;">
          <div class="box-item">
            <div class="box-title">
              <span>坐席在线信息</span>
            </div>
            <div class="box-main">
              <left-top-list ref="leftTop"></left-top-list>
            </div>
          </div>
        </div>
        <div style="height: 145px;margin-top: 10px">
          <div class="box-item">
            <div class="box-title">
              <span>用户健康信息</span>
            </div>
            <div class="box-main">
             <person-info ref="person"></person-info>
            </div>
          </div>
        </div>
        <div style="height: 300px;margin-top: 10px;">
          <div class="box-item">
            <div class="box-title">
              <span>工单统计</span>
            </div>
            <div class="box-main">
              <left-center-order ref="leftOrder"></left-center-order>
            </div>
          </div>
        </div>
        <div style="height: calc(100% - 635px);margin-top: 10px;">
          <div class="box-item">
            <div class="box-title">
              <span>工单处理列表</span>
            </div>
            <div class="box-main">
              <left-bottom-table ref="leftTable"></left-bottom-table>
            </div>
          </div>
        </div>
      </el-col>
      <el-col :span="9" class="col-height">
        <div style="height: 140px;margin: 0 10px">
          <div class="box-item">
            <center-top-list ref="topCenter"></center-top-list>
          </div>
        </div>
        <div style="height: calc(100% - 360px);margin: 10px 10px 0">
          <iframe-map :mapCenter="mapCenter"></iframe-map>
        </div>
        <div style="height: 200px;margin: 10px 10px 0">
          <div class="box-item">
              <center-bottom-list ref="bottomCenter"></center-bottom-list>
          </div>
        </div>
      </el-col>
      <el-col :span="7" class="col-height">
        <div style="height: 32.5%">
          <div class="box-item">
            <div class="box-title">
              <span>各区服务人数占比</span>
            </div>
            <div class="box-main">
              <right-top-service ref="rightService"></right-top-service>
            </div>
          </div>
        </div>
        <div style="height: 1.25%"></div>
        <div style="height: 32.5%;">
          <div class="box-item">
            <div class="box-title">
              <span>全年(按月)报警报表</span>
            </div>
            <div class="box-main">
              <right-center-alarm ref="rightAlarm"></right-center-alarm>
            </div>
          </div>
        </div>
        <div style="height: 1.25%"></div>
        <div style="height: 32.5%;">
          <div class="box-item">
            <div class="box-title">
              <span>服务项目类别及占比</span>
            </div>
            <div class="box-main">
              <right-bottom-type ref="rightType"></right-bottom-type>
            </div>
          </div>
        </div>
      </el-col>
    </el-row>
  </div>
<!--  老干局  -->
  <div v-else style="height: calc(100% - 20px);padding-top: 10px;">
    <div style="height: 100%">
      <el-row style="height: 100%;">
        <el-col :span="8" class="col-height">
          <div style="height: 80px;">
            <div class="box-item">
              <left-top-list ref="leftTop"></left-top-list>
            </div>
          </div>
          <div style="height: 145px;margin-top: 10px">
            <div class="box-item">
              <div class="box-title">
                <span>用户健康信息</span>
              </div>
              <div class="box-main">
                <person-info ref="person"></person-info>
              </div>
            </div>
          </div>
          <div style="height: calc(100% - 485px);margin-top: 10px;">
            <div class="box-item">
              <div class="box-title">
                <span>工单统计</span>
              </div>
              <div class="box-main">
                <left-center-order ref="leftOrder"></left-center-order>
              </div>
            </div>
          </div>
          <div style="height: 230px;margin-top: 10px">
            <div class="box-item">
              <center-bottom-list ref="bottomCenter"></center-bottom-list>
            </div>
          </div>
        </el-col>
        <el-col :span="9" class="col-height">
          <div style="height: 140px;margin: 0 10px">
            <div class="box-item">
              <center-top-list ref="topCenter"></center-top-list>
            </div>
          </div>
          <div style="height: calc(100% - 150px);margin: 10px 10px 0">
            <iframe-map :mapCenter="mapCenter"></iframe-map>
          </div>
        </el-col>
        <el-col :span="7" class="col-height">
          <div style="height: calc(100% - 240px)">
            <div style="height: 50%">
              <div class="box-item">
                <div class="box-title">
                  <span>用户总数及被服务用户数各街镇分布</span>
                </div>
                <div class="box-main">
                  <right-top-service ref="rightService"></right-top-service>
                </div>
              </div>
            </div>
            <div style="height: calc(50% - 10px);margin-top: 10px">
              <div class="box-item">
                <div class="box-title">
                  <span>全年(按月)报警报表</span>
                </div>
                <div class="box-main">
                  <right-center-alarm ref="rightAlarm"></right-center-alarm>
                </div>
              </div>
            </div>
          </div>
          <div style="height: 230px;margin-top: 10px">
            <div class="box-item">
              <div style="height: 10px;"></div>
              <div style="height: calc(100% - 10px)">
                <left-bottom-table ref="leftTable"></left-bottom-table>
              </div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
</template>

<script>
import leftTopList from './weiNingComponents/leftTopList'
import personInfo from './weiNingComponents/personInfo'
import leftCenterOrder from './weiNingComponents/leftCenterOrder'
import leftCenterToday from './weiNingComponents/leftCenterToday'
import leftCenterHistory from './weiNingComponents/leftCenterHistory'
import leftBottomTable from './weiNingComponents/leftBottomTable'
import centerTopList from './weiNingComponents/centerTopList'
import iframeMap from './childComponents/iframeMap'
import centerBottomList from './weiNingComponents/centerBottomList'
import rightTopService from './weiNingComponents/rightTopService'
import rightCenterAlarm from './weiNingComponents/rightCenterAlarm'
import rightBottomType from './weiNingComponents/rightBottomType'
import {querydataviewalarm, querydataviewcount, querysosalarmbyaid} from '../../api/alarmservice'
import {querydataviewdevicecount, querydataviewpersoncount, querydataviewservicecount} from '../../api/home'
import {queryoldpersonbypids} from '../../api/handlealarm'
export default {
  name: 'weiNing',
  components: {leftTopList, personInfo, leftCenterOrder, leftCenterToday, leftCenterHistory, leftBottomTable, centerTopList, iframeMap, centerBottomList, rightTopService, rightCenterAlarm, rightBottomType},
  data () {
    return {
      isWeiNing: true,
      timerLoad: null,
      isMqtt: false,
      oldpersonArr: [],
      mapCenter: {
        isJiaOld: false
      }
    }
  },
  created () {
    // weiNing.vue 数据互通
    this.golobleObject.getMqttNewData = this.getMqttNewData1 // mqtt报警过来请求接口更新
    this.golobleObject.updateTableAlarm = this.getMqttNewData2 // mqtt处理报警
    // 登录返回 mqtt 中，包含 “/1/14/1323” 这个topic ，判断为老干局，需要显示老干局的监控页面
    let aa = '/1/14/1323'
    this.isWeiNing = this.$store.state.user.mqtts.indexOf(aa) === -1
    // console.log('mqtt', this.$store.state.user.mqtts, this.isWeiNing, this.$store.state.user.mqtts.indexOf(aa))
  },
  mounted () {
    this.timerLoad = setInterval(() => {
      // console.log('刷新')
      this.getTimeRefresh()
    }, 2 * 60 * 1000)
    this.getSevenData()
    this.getLoadData()
    this.getMqttNewData()
    this.getPersonStatistics()
    this.getOrderData()
  },
  destroyed () {
    clearInterval(this.timerLoad)
  },
  methods: {
    getTimeRefresh () {
      this.getSevenData()
      this.getMqttNewData()
      this.getOrderData()
    },
    // 人员信息
    getPersonStatistics () {
      querydataviewpersoncount().then(res => {
        let obj = res.data.dataviewpersoncount
        this.$refs.person.getPersonVal(obj)
      }).catch(() => {})
    },
    // 地图下面设备统计
    getLoadData () {
      querydataviewdevicecount().then(res => {
        let obj = res.data.dataviewdevicecount
        this.$refs.bottomCenter.getDeviceCount(obj)
      }).catch(() => {})
    },
    getSevenData () {
      querydataviewcount().then(res => {
        this.$refs.topCenter.getAlarmCount(res.data) // 地图上方数据
        this.$refs.leftTop.getDataList(res.data.dataviewcount) // 左上方 数据在线统计
      }).catch(() => {})
    },
    getOrderData () {
      querydataviewservicecount().then(res => {
        // console.log(678, res.data.dataviewservicecount.CustomerOnlineType)
        this.$refs.leftOrder.getTypeTodayVal(res.data.dataviewservicecount.ServiceTypeCountAndComplete) // 工单统计  当天服务数量统计
        this.$refs.leftOrder.getTypeHistoryVal(res.data.dataviewservicecount.ServiceTypeCount) // 工单统计  服务总数统计
        this.$refs.rightAlarm.getYearAlarmData(res.data.dataviewservicecount.OneYearAlarmType) // 全年(按月)报警报表
        if (this.isWeiNing) { // 慰宁页面
          this.$refs.rightType.getTypePieData(res.data.dataviewservicecount.ProjectTypeCount) // 服务项目类别及占比
        }
        this.$refs.rightService.getAreaPieData(res.data.dataviewservicecount.ServicesCountWithZone) // 各区服务人数占比
        this.$refs.leftTop.getCustomerOnlineType(res.data.dataviewservicecount.CustomerOnlineType) // 左上方 客服在线统计
      }).catch(() => {})
    },
    // mqtt推送过来请求
    getMqttNewData1 (alarmObj) {
      this.golobleObject.getMqttAddCnt(alarmObj) // 地圖上面 报警总数 加1
      this.isMqtt = true
      this.getMqttNewData(alarmObj)
      this.getMqttByAlarmId(alarmObj)
    },
    // mqtt 获取地图信息
    getMqttByAlarmId (alarmObj) {
      let data = {
        alarmid: alarmObj.alarmid
      }
      querysosalarmbyaid(data).then(res => {
        this.golobleObject.getAlarmMarker(res.alarm)
      })
    },
    // 初始化数据
    getMqttNewData2 () {
      this.isMqtt = false
      this.getMqttNewData()
    },
    async getMqttNewData (alarObj) {
      querydataviewalarm().then(res => {
        let arr1 = res.data.dataviewalarm.slice(0, 5)
        let arr = []
        let pids = []
        for (let i = 0; i < arr1.length; i++) {
          if (arr1[i].pid !== 0) { // 穿戴设备
            if (pids.indexOf(arr1[i].pid) === -1) {
              pids.push(arr1[i].pid)
            }
          }
        }
        if (pids.length !== 0) {
          this.getPhotoUrl(pids).then((data) => {
            let persons = data
            for (let i = 0; i < arr1.length; i++) {
              let obj = arr1[i]
              obj.person = ''
              obj.alarObj = ''
              if (alarObj) {
                if (alarObj.alarmid === arr1[i].id) {
                  obj.alarObj = alarObj
                }
              }
              for (let j = 0; j < persons.length; j++) {
                if (arr1[i].pid === persons[j].id) {
                  obj.person = persons[j]
                }
              }
              arr.push(obj)
            }
            this.getSendData(arr)
          })
        } else {
          this.getSendData(arr1)
        }
      }).catch(() => {})
    },
    getSendData (arr) {
      this.$refs.leftTable.getListData(arr) // 工单处理列表
      if (this.isMqtt && arr.length > 0) {
        // this.golobleObject.getAlarmMarker(arr[0]) // 地图
      }
    },
    async getPhotoUrl (pids) {
      let arr = []
      let data = {
        pids: pids
      }
      await queryoldpersonbypids(data).then(res => {
        arr = res.data.persons
      }).catch(() => {})
      return arr
    }
  }
}
</script>

<style scoped>
.col-height{
  height: 100%;
}
.box-item{
  height: 100%;
  background: url("../../assets/SHscreen/monitor_bg.png") no-repeat;
  background-size: 100% 100%;
}
.box-title{
  height: 34px;
  line-height: 40px;
  font-size: 16px;
  color: #feffff;
  font-weight: 800;
  margin-left: 15px;
  background: url("../../assets/SHscreen/monitor_title.png") no-repeat left bottom;
}
.box-main{
  height: calc(100% - 40px);
  padding-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/components/monitoring/weiNing.vue